exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal___1u4mK {\n  display: flex;\n  padding-left: 44px;\n  padding-right: 44px;\n  padding-bottom: 44px;\n}\n@media (max-width: 767px) {\n  .modal___1u4mK {\n    padding-left: 22px;\n    padding-right: 22px;\n    padding-bottom: 22px;\n  }\n}\n.body___2koiE {\n  display: flex;\n  flex-direction: column;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 99.99%;\n}\n.cta___3KtCY {\n  font-weight: 500;\n}\n.title___yVU4J {\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 24px;\n  color: #21201f;\n  margin-top: 44px;\n  margin-bottom: 32px;\n}\n.title___yVU4J.single___1_BCV {\n  margin-bottom: 8px;\n}\n.actions___1qCLD {\n  margin-top: 32px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.separator___qK9MX {\n  width: 1em;\n  height: 1em;\n}\n", ""]);

// exports
exports.locals = {
	"modal": "modal___1u4mK",
	"body": "body___2koiE",
	"cta": "cta___3KtCY",
	"title": "title___yVU4J",
	"single": "single___1_BCV",
	"actions": "actions___1qCLD",
	"separator": "separator___qK9MX"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/modals/ExistingDraftsForCardSuiteModal/ExistingDraftsForCardSuiteModal.module.less
// module id = 1568
// module chunks = 51